// Additional polyfills
import "custom-event-polyfill";
import "url-polyfill";

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import {createBootstrap} from 'bootstrap-vue-next'

// import { IconsPlugin } from 'bootstrap-vue-3';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import globals from './globals';
import Popper from 'popper.js';
import registerFilters from './filters/registerFilters';
// import store from './store';
import { useMainStore } from './store'; // Import the store

import useAuth from './auth/useAuth';
import useAppInsights from './plugins/useAppInsights';
import hasValue from '@/lib/hasValue';
import Vue3ColorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import globalComponents from './plugins/global-components';


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
// import 'vue3-date-time-picker/style.css';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { createPinia } from 'pinia';
import "@/styles.css"


// Font Awesome configuration
library.add(faUserSecret);

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(Vue3ColorPicker)
app.use(VueSweetalert2);
app.component('VueDatePicker', VueDatePicker);

 

// Register Font Awesome Icon component globally
app.component('font-awesome-icon', FontAwesomeIcon);

const appInsights = useAppInsights(app);

// Disable GPU acceleration globally for Popper.js (only if needed)
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

app.config.productionTip = false;

if(appInsights){

  // Global error handling
  app.config.errorHandler = async (error, instance) => {
    appInsights.trackException({ exception: error });
    window.location.href = "/error?error=" + error;
  };
  
  window.onerror = function (message, source, lineno, colno, error) {
    appInsights.trackException({ exception: error });
    window.location.href = "/error?error=" + message;
  };
  
  window.onunhandledrejection = function (event) {
    appInsights.trackException({ exception: event });
    window.location.href = "/error?error=" + event.reason;
  };
}



// Register plugins
// app.use(BootstrapVue3);
// Create BootstrapVueNext instance and register all components
const bootstrapVue = createBootstrap({
  // Optionally, you can define specific components if needed, but for all:
  components: true, // Register all components globally
  directives: true, // Register all directives globally (if needed)
});


app.use(bootstrapVue); // Use the BootstrapVue instance
app.use(globalComponents);
// app.use(IconsPlugin); // Uncomment if Icons are needed

// Use custom functions
registerFilters(app); // Register custom filters globally
useAuth(app);         // Set up authentication

// Global mixin for form validation and other shared methods
app.mixin({
  data() {
    return {
      ...globals(),
      filedValidationStatus: {}, // Holds form validation statuses
    };
  },
  methods: {
    requiredField(key, field) {
      // Directly assign the value to the reactive object in Vue 3
      this.filedValidationStatus[key] = hasValue(field);
      return this.filedValidationStatus[key];
    },
    validateAttract(key, attractId, noAttractOption) {
      const isValid = !!(attractId || noAttractOption);
      this.filedValidationStatus[key] = isValid; // Direct assignment
      return isValid;
    },
    mustSameWith(key, field1, field2) {
      this.filedValidationStatus[key] = field1 === field2; // Direct assignment
      return this.filedValidationStatus[key];
    }
  },
  computed: {
    isModelValid() {
      return !this.hasModelError;
    },
    hasModelError() {
      return Object.values(this.filedValidationStatus).some(f => !f);
    },
  },
});

// Provide App Insights globally
app.provide('$appInsights', appInsights);

// Use Vue Router and other necessary plugins
app.use(router);
// app.use(store(app)); // Ensure you add your store if you're using Vuex
app.provide('store', useMainStore());

// Mount the Vue app to the #app element
app.mount('#app');
